/*
    This file is the entry point for webpack to generate the shared-component bundle for Locale FR
    please see bundle.tsx for components declarations
*/
export * from './bundle';
import { initI18n } from '../../src/localization/i18n';
// We specifically only embed FR tranlations
import translations from '../../src/localization/translations/fr/sharedComponents.json';
initI18n('fr', { sharedComponents: translations });
